import { createBackendUrl } from './urls';
import { httpGetAsync } from '../widget/src/utils/httpGetAsync';

export async function attendeeIPTimezone(): Promise<string> {
  try {
    return await new Promise((rs, rj): void => {
      return httpGetAsync(
        createBackendUrl('v1/attendees/timezone'),
        (res) => {
          const resData = JSON.parse(res);
          rs(resData.timezone);
        },
        rj
      );
    });
  } catch {
    return 'UTC';
  }
}
